import './style.scss';
import Swiper from 'swiper';
import {Navigation, Pagination} from "swiper/modules";

export function quote_block() {
    const blocks = document.querySelectorAll('.quote_block');
    if (!blocks.length) return;

    blocks.forEach(block => {
        const swiperContainer = block.querySelector('.swiper');
        if(!swiperContainer) return;
        
        new Swiper(swiperContainer, {
            slidesPerView: 1,
            loop: true,
            modules: [Navigation, Pagination],
            navigation: {
                nextEl: block.querySelector('.swiper-button-next'),
                prevEl: block.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: block.querySelector('.swiper-pagination'),
            },
        });
    });
}
